"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventsApi = exports.EventsApiFactory = exports.EventsApiFp = exports.EventsApiAxiosParamCreator = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
// @ts-ignore
const base_1 = require("../base");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
/**
 * EventsApi - axios parameter creator
 */
const EventsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Publish Event to Amplitude
         * @param {EventsCreateAmplitudeEventRequest} eventsCreateAmplitudeEventRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAmplitudeEvent: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ eventsCreateAmplitudeEventRequest }, options = {}) {
            // verify required parameter 'eventsCreateAmplitudeEventRequest' is not null or undefined
            (0, common_1.assertParamExists)('createAmplitudeEvent', 'eventsCreateAmplitudeEventRequest', eventsCreateAmplitudeEventRequest);
            const localVarPath = `/v1/events/amplitude`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/events/amplitude`,
                sdkMethod: 'createAmplitudeEvent',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(eventsCreateAmplitudeEventRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.EventsApiAxiosParamCreator = EventsApiAxiosParamCreator;
/**
 * EventsApi - functional programming interface
 */
const EventsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.EventsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Publish Event to Amplitude
         * @param {EventsCreateAmplitudeEventRequest} eventsCreateAmplitudeEventRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAmplitudeEvent(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createAmplitudeEvent(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EventsApi.createAmplitudeEvent']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.EventsApiFp = EventsApiFp;
/**
 * EventsApi - factory interface
 */
const EventsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.EventsApiFp)(configuration);
    return {
        /**
         *
         * @summary Publish Event to Amplitude
         * @param {EventsCreateAmplitudeEventRequest} eventsCreateAmplitudeEventRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAmplitudeEvent(params, options) {
            return localVarFp
                .createAmplitudeEvent(params, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.EventsApiFactory = EventsApiFactory;
/**
 * EventsApi - object-oriented interface
 */
class EventsApi extends base_1.BaseAPI {
    /**
     * URL `/v1/events/amplitude`
     *
     * @summary Publish Event to Amplitude
     * @param {EventsCreateAmplitudeEventRequest} eventsCreateAmplitudeEventRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAmplitudeEvent(params, options) {
        return (0, exports.EventsApiFp)(this.configuration)
            .createAmplitudeEvent(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.EventsApi = EventsApi;
//# sourceMappingURL=events-api.js.map